import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CartIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Cart",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.18 27.18c0 1.29-1.04 2.33-2.33 2.33s-2.33-1.04-2.33-2.33 1.04-2.33 2.33-2.33 2.33 1.04 2.33 2.33m12.47 0c0 1.29-1.04 2.33-2.33 2.33s-2.33-1.04-2.33-2.33 1.04-2.33 2.33-2.33 2.33 1.04 2.33 2.33m6.39-24.69h-4.57c-.93 0-1.7.68-1.84 1.57s-.62 4.05-.62 4.05H5.41c-1.04 0-1.97.47-2.6 1.2-.5.6-.8 1.38-.8 2.23 0 .2.02.41.05.6v-.02l1.25 7.5a4.17 4.17 0 0 0 4.01 3.39h11.6c2-.04 3.65-1.49 4-3.39v-.03l1.25-7.5.87-5.86h3.1c1.03 0 1.87-.84 1.87-1.87s-.84-1.87-1.87-1.87h-.13l.03-.02Zm-8.08 12.17h-3.27l.17-2.81h3.57zm-8.74 0-.38-2.81h4.2l-.22 2.81zm3.5 1.86-.17 2.78h-2.7l-.37-2.78zm-5.74-4.7.37 2.84H6.19l-.46-2.81zm-2.06 7.16-.41-2.49H9.6l.37 2.78H7.25a.45.45 0 0 1-.33-.28Zm11.99.29h-2.5l.17-2.78h3.08l-.41 2.49a.48.48 0 0 1-.33.29Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.43 29.28c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71a1.71 1.71 0 1 0-.002 3.418 1.71 1.71 0 0 0 .002-3.418M26.57 29.28c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71c-.94 0-1.71.77-1.71 1.71s.77 1.71 1.71 1.71 1.71-.77 1.71-1.71-.77-1.71-1.71-1.71M27.14 19H8.86c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-.63-.51-1.14-1.14-1.14H2a1.14 1.14 0 1 1 0-2.28h2.29c1.89 0 3.43 1.54 3.43 3.43v10.29c0 .63.51 1.14 1.14 1.14h18.29c.63 0 1.14-.51 1.14-1.14V9.88H11.14a1.14 1.14 0 1 1 0-2.28h18.29c.63 0 1.14.51 1.14 1.14v6.86c0 1.89-1.54 3.43-3.43 3.43Z"
      })
    })
  }));
};
CartIcon.displayName = 'CartIcon';